var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 18,
    cy: 18,
    r: 15,
    stroke: "#6F706F",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 8",
    d: "M12 18L18 12",
    stroke: "#6F706F",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 9",
    d: "M12 18H24",
    stroke: "#6F706F",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 10",
    d: "M12 18L18 24",
    stroke: "#6F706F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircledIcon);
export default __webpack_public_path__ + "static/media/arrow-circled-icon.b9c5d98ac2462c01cafa51109cb91fb2.svg";
export { ForwardRef as ReactComponent };